import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-usefull-links',
  templateUrl: './usefull-links.component.html',
  styleUrls: ['./usefull-links.component.scss']
})
export class UsefullLinksComponent implements OnInit {
//   data=[
//     {"title":"Uttar Pradesh Food and Civil Supplies Department","img_src":"https://images.vartulz.com/upfacsd.png","web_url":"https://fcs.up.gov.in/"},
//     {"title":"Uttar Pradesh Power Corporation Limited (View Bill & Pay Bill)","img_src":"https://images.vartulz.com/uppcl.png","web_url":"https://uppcl.mpower.in/wss/index.htm"},
//     {"title":"Income Tax Department ","img_src":"https://images.vartulz.com/itd.png","web_url":"https://eportal.incometax.gov.in/iec/foservices/#/login"},
//     {"title":"Online Bank Account opening Union Bank Of India","img_src":"https://images.vartulz.com/unoi.png","web_url":"https://www.unionbankofindia.co.in/english/saving-bank-account.aspx"},
//     {"title":"Online Bank Account opening IDFC First Bank","img_src":"https://images.vartulz.com/ifb.png","web_url":"https://www.idfcfirstbank.com/"},
//     {"title":"Ministry of Labour","img_src":"https://images.vartulz.com/mol.png","web_url":"https://register.eshram.gov.in/#/user/self"},
//     {"title":"Unique Identification Authority of India (myAadhaar)","img_src":"https://images.vartulz.com/adc.png","web_url":"https://myaadhaar.uidai.gov.in/"},
//     {"title":"National Health Authority ","img_src":"https://images.vartulz.com/pmj.png","web_url":"https://bis.pmjay.gov.in/BIS/selfprintCard"},
//     {"title":"PM-Kisan Samman Nidhi ","img_src":"https://images.vartulz.com/pmksn.png","web_url":"https://fw.pmkisan.gov.in/NewHome3.aspx"},
//     {"title":"PM-Kisan Samman Nidhi (New Farmer Registration)","img_src":"https://images.vartulz.com/pmksnr.png","web_url":"https://pmkisan.gov.in/RegistrationFormnew.aspx"},
//     {"title":"e-filing your Income Tax Return ","img_src":"https://images.vartulz.com/t2w.png","web_url":"https://tax2win.in/"},
//     {"title":"Passport Seva ","img_src":"https://images.vartulz.com/psk.png","web_url":"https://portal2.passportindia.gov.in/AppOnlineProject/user/RegistrationBaseAction?request_locale=en"},
//     {"title":"Employees' Provident Fund (EPF) ","img_src":"https://images.vartulz.com/epfd.png","web_url":"https://www.epfindia.gov.in/site_en/For_Employees.php"},
//     {"title":"Parivahan Sarathi (Ministry of Road Transport & Highway)","img_src":"https://images.vartulz.com/ps.png","web_url":"https://sarathi.parivahan.gov.in/sarathiservice/stateSelection.do"},
//     {"title":"Search Name in Voter List","img_src":"https://images.vartulz.com/eci.png","web_url":"https://electoralsearch.in/"},
//     {"title":"New Voter Card Registration","img_src":"https://images.vartulz.com/ecir.png","web_url":"https://www.nvsp.in/Account/Login"},
//     {"title":"Pradhan Mantri MUDRA Yojana (PMMY)","img_src":"https://images.vartulz.com/pmy.png","web_url":"https://www.mudra.org.in/"},
//     {"title":"Online Bank Account opening Indusind Bank","img_src":"https://images.vartulz.com/isb.png","web_url":"https://myaccount.indusind.com/savingsaccount/index.aspx?utm_code=z_mktgcamp&utm_campaign=wc_sa&utm_source=OneCode&utm_medium=3080256&utm_content=mailer"},
//     {"title":"MSME","img_src":"https://images.vartulz.com/msme.png","web_url":"https://udyamregistration.gov.in/Government-India/Ministry-MSME-registration.htm"},
//     {"title":"Online Bank Account opening Bank Of Baroda","img_src":"https://images.vartulz.com/bob.png","web_url":"https://www.bankofbaroda.in/personal-banking/accounts/saving-accounts"},
//     {"title":"Online Bank Account opening PNB","img_src":"https://images.vartulz.com/pnb.png","web_url":"https://pnbnet.org.in/OOSA/CustomerEntry.jsp"},
//     {"title":"Online Bank Account opening HDFC","img_src":"https://images.vartulz.com/hdfc.png","web_url":"https://apply.hdfcbank.com/vivid/s_account_newuiux#SA_Landingn"},
//     {"title":"Online Bank Account opening UCO Bank","img_src":"https://images.vartulz.com/uco.png","web_url":"https://apps.ucoonline.in/Lead_App/lead_web.jsp "},
//     {"title":"Goods and Service Tax","img_src":"https://images.vartulz.com/gst.png","web_url":"https://reg.gst.gov.in/registration/"},
    
// ]
data:any;
constructor(private toastr: ToastrService,private auth :AuthService,private ngx:NgxUiLoaderService) {
}

  ngOnInit(): void {
  this.getUsefullLinkList();
  
  }
  links(url){
    console.log(url);

    window.open(url);
  }

  /* presentation only: the API's attachment images are dead — logos are
     bundled locally in assets/links/, keyed by the link's hostname
     (fetched 2026-07-21; the img (error) handler falls back to _link.svg). */
  logoFor(url: string): string {
    try {
      const host = new URL(url).hostname.replace(/^www\./, '');
      return 'assets/links/' + host + '.png';
    } catch (e) {
      return 'assets/links/_link.svg';
    }
  }

  getUsefullLinkList(){
    this.ngx.start();
    this.auth.getUsefullLinkListApi().subscribe((res:any)=>{
      this.ngx.stop();

      if(res.status_code == 1){
        this.data = res.object
        this.toastr.success(res.message);
      }else {
        this.data = [];
        this.toastr.error(res.error.message);

      }
    },err=>{
      this.ngx.stop();

    })
  }
 
}
